



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import "dropzone/dist/dropzone.css";
import Dropzone from "dropzone";
import { AwsService as awsApi } from "@/common/api/services/AwsService";
import { FileManagementService as fileApi } from "@/common/api/services/FileManagementService";
import { FileManagementAddFileUploadResponseApiRespoonse } from "@/common/api";
Dropzone.autoDiscover = false;

@Component({
  name: "uploadFile",
  components: {},
})
export default class uploadFile extends Vue {
  @Prop({
    default: () => {
      return {
        uploadMultiple: false,
      };
    },
  })
  options;

  @Prop({
    default: () => [],
  })
  files;

  selfFiles = [];

  dropzone;
  // files = [];
  fileErrors = [];
  @Watch("files")
  watchFileInput() {
    this.selfFiles = [...this.files];
  }
  mounted() {
    this.selfFiles = [...this.files];
    let localOptions = {
      // The URL will be changed for each new file being processing
      url: "/",
      // Since we're going to do a `PUT` upload to S3 directly
      method: "PUT",
      // Hijack the xhr.send since Dropzone always upload file by using formData
      // ref: https://github.com/danialfarid/ng-file-upload/issues/743
      sending(file, xhr) {
        let _send = xhr.send;
        xhr.send = () => {
          _send.call(xhr, file);
        };
      },
      // Upload one file at a time since we're using the S3 pre-signed URL scenario
      parallelUploads: 1,
      // Content-Type should be included, otherwise you'll get a signature
      // mismatch error from S3. We're going to update this for each file.
      header: "",
      // Customize the wording
      dictDefaultMessage: document.querySelector("#dropzone-message").innerHTML,
      // We're going to process each file manually (see `accept` below)
      autoProcessQueue: false,
      // Here we request a signed upload URL when a file being accepted
      accept: async (file, done) => {
        const extension = file.name.split(".").pop();
        const result = await awsApi.awsUploadFilePresign({
          filePath: file.upload.uuid + "." + extension,
        });
        file.uploadURL = result.data.presign.url;
        (file.filePath = file.upload.uuid + "." + extension), done();
        setTimeout(() => this.dropzone.processFile(file));
      },
    };
    // Instantiate Dropzone
    this.dropzone = new Dropzone(this.$el, {
      ...localOptions,
      ...this.options,
    });
    // Set signed upload URL for each file
    this.dropzone.on("processing", (file) => {
      this.dropzone.options.url = file.uploadURL;
    });
    this.dropzone.on("success", (file) => this.addFile(file));
    this.dropzone.on("uploadprogress", (file) => this.addFile(file));
    this.dropzone.on("error", (file, message) => this.addFile(file, message));
  }

  open() {
    this.dropzone.hiddenFileInput.click();
  }

  async addFile(file, message = "") {
    let findFile = this.selfFiles.find(
      (item) => item.upload.uuid === file.upload.uuid
    );
    if (findFile) {
      findFile = file;
    } else {
      if (file.status === "error") {
        file.errorMessage = message;
      }
      this.selfFiles.push(file);
    }
    if (file.status === "success") {
      // call api add file
      let result: FileManagementAddFileUploadResponseApiRespoonse;
      try {
        result = await fileApi.groupAdminFilesAddFileUpload({
          name: file.filePath,
          nameOriginal: file.name,
          sipPath: "",
          category: "File",
          mimeType: file.type,
          size: file.size,
          md5: "md5",
        });
      } catch (error) {
        result = error.body;
      }
      if (result.status === "error") {
        file.status = "error";
        file.errorMessage = result.message;
      } else {
        console.log("w");
        this.$emit("changed", [result.data.file]);
      }
    }
    this.reRender();
  }

  public reRender() {
    this.selfFiles.unshift({ w: 1 });
    this.selfFiles.shift();
  }

  public removeFile(file, index) {
    // this.dropzone.files;
    const fileUpload = this.dropzone.files.find(
      (item) => item.filePath === file.name
    );
    if (fileUpload) {
      // instance of file
      this.dropzone.removeFile(fileUpload);
    }
    this.selfFiles.splice(index, 1);
    this.$emit(
      "changed",
      this.selfFiles.filter((item) => item.status === "success")
    );
  }
}
